import { Grid, Row } from 'rsuite';
import styled from 'styled-components';

export const EventGrid = styled(Grid)`
  width: 766px;
  border: 1px solid #e5e5ea;
  padding: 3px 10px 3px 10px;
  border-radius: 5px;
`;

export const EventRow = styled(Row)`
  position: relative;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 5px;
  &:nth-last-child(n + 4) {
    margin-bottom: 5px;
  }
`;

export const FilterLabel = styled.div`
  margin-top: 5px;
  text-align: right;
  font-weight: bold;
`;

export const ErrorMessage = styled.div`
  color: #f44336;
  font-size: 14px;
`;
